//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: "check_room_record",
        data(){
            return{
                showShift:true,
                maxDate:'',
                shifts_value:'',
                shifts:['早班','中班','晚班','无班次'],
                agent_value:'',
                agent_options:[],
                start_date:'',
                end_date:'',
                form_type:'',
                form_type_options:[],
                keyword: '',
                page: 1,
                id:this.$route.query.id,
                tabVal:this.$route.query.tabVal,
                listData: [],
                pullupDefaultConfig: {
                    content: '上拉加载更多',
                    pullUpHeight: 60,
                    height: 40,
                    autoRefresh: false,
                    downContent: '释放后加载',
                    upContent: '上拉加载更多',
                    loadingContent: '加载中...',
                    clsPrefix: 'xs-plugin-pullup-'
                },
                pulldownDefaultConfig: {
                    content: '下拉刷新',
                    height: 40,
                    autoRefresh: false,
                    downContent: '下拉刷新',
                    upContent: '释放后刷新',
                    loadingContent: '正在刷新...',
                    clsPrefix: 'xs-plugin-pulldown-'
                },
            }
        },
        methods:{
            formChange(value){
                console.log(value)
                if(value ==12 || value == 13){
                    this.showShift = false
                    this.shifts_value = ''
                }else{
                    this.showShift = true
                }
            },
            //查房人
            apiGetAgentList(){
                let that = this
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id:this.$route.query.id
                }
                Api.checkRoomApi.getAgentListFn(params).then ( res => {
                    console.log('查房人',res)
                    if(res.errcode == 200){  
                        if(res.data.length){
                            this.agent_options = []
                            for(let item of res.data){
                                this.agent_options.push({
                                    key:item.agent_id,
                                    value:item.agent_name
                                })
                            } 
                        }
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //所用表格
            apiGetFormTypeList(){
                let that = this
                let params = {
                    token: this.$cookie.get('token')
                }
                Api.checkRoomApi.getFormTypeListFn(params).then ( res => {
                    console.log('表格列表',res)
                    if(res.errcode == 200){  
                        if(res.data.length){
                            this.form_type_options = []
                            for(let item of res.data){
                                this.form_type_options.push({
                                    key:item.form_id,
                                    value:item.form_name
                                })
                            } 
                        }
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '年' + m + '月' + d + '日'
            },
            cInput(){
                this.keyword = ''
                this.refresh()
            },
            searchBtn(){
                this.$nextTick(() => {
                    this.$refs.scrollerBottom.reset({top: 0})
                    this.refresh()
                })
            },
            clearBtn(){
                let that = this
                that.agent_value = ''
                that.form_type = ''
                that.start_date = ''
                that.end_date = ''
                this.shifts_value = ''
                this.refresh()
                this.$vux.toast.show({
                    type: 'success',
                    text: '已清空',
                })
            },
            apiCheckRoomRecord(str){
                this.$vux.loading.show({
                    text: '正在加载'
                })
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id,
                    form_id: this.form_type,
                    agent_id:this.agent_value,
                    start_date:this.start_date,
                    end_date:this.end_date,
                    shifts:this.shifts_value,
                    page: this.page,
                    limit:10
                }
                console.log(params)
                Api.checkRoomApi.getFormDataListFn(params).then ( res => {
                    console.info('列表数据',res)
                    if(res.errcode == 200){
                        this.page++
                        this.$nextTick(() => {
                            this.$refs.scrollerBottom.reset()
                        })
                        if(res.data.list.length){
                            for(let item of res.data.list){
                                this.listData.push(item)
                            }
                            if(str == 'refresh'){
                                this.$refs.scrollerBottom.enablePullup()//启用上拉加载插件
                                this.$refs.scrollerBottom.donePulldown()//设置下拉刷新操作完成，在数据加载后执行
                            }else{
                                this.$refs.scrollerBottom.enablePullup()//启用上拉加载插件
                                 this.$refs.scrollerBottom.donePullup()//设置上拉加载操作完成，在数据加载后执行
                            }
                            if(res.data.list.length != 10){
                                this.$refs.scrollerBottom.disablePullup()// 禁用上拉加载，在没有更多数据时执行   
                            }
                        }else{
                            // this.listData = res.data.list
                            this.$refs.scrollerBottom.disablePullup()// 禁用上拉加载，在没有更多数据时执行
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: '暂无更多数据',
                            })
                        }
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //下拉刷新
            refresh() {
                this.listData = []
                this.page = 1
                this.apiCheckRoomRecord('refresh')
            },
            //上拉加载
            loadMore() {
                this.apiCheckRoomRecord()
            },
            getNowFormatDate() {
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
            editFormDetailList(answer_id,form_id){
                console.log("_____")
                let get_form_id = ''
                if(form_id < 10){
                    get_form_id = '100'+form_id
                }
                if(form_id >= 10 && form_id < 20){
                    get_form_id = '10'+form_id
                }
                let query = {
                    id: this.$route.query.id,
                    form_id: get_form_id,
                    tabVal: this.$route.query.tabVal,
                    start_date:this.start_date,
                    end_date:this.end_date,
                    shifts_value:this.shifts_value
                }
                this.$router.push({
                    path: './check_room_service',
                    query:query
                })
            }
        },
        created (){
            this.start_date = this.getNowFormatDate()
            this.end_date = this.getNowFormatDate()
            this.maxDate = this.getNowFormatDate()
            // this.$nextTick(() => {
            //     this.$refs.scrollerBottom.reset({top: 0})
            // })
            this.apiGetFormTypeList()
            this.apiGetAgentList()
            // this.apiFormList()
            this.apiCheckRoomRecord()
        }
    }



// WEBPACK FOOTER //
// ./src/components/new_check_room_record.vue